<template>
    <div class="leave-request">
        <RequestYearToolbar
            title="My Leave Requests"
            button-label="New Leave Request"
            :year="selectedYear"
            @year-changed="handleYearChanged"
            @create="handleCreateButton"
        />
        <List
            :is-loading="isLoading"
            :total-count="totalCount"
            :current-page="currentPage"
            :limit="limit"
            :requests-data-list="requestList"
            @on-page-change="handleOnPageChanged"
            @reload="handleReload"
        />
        <CreateModal ref="CreateRequest" @create="handleReload"></CreateModal>
    </div>
</template>

<script>
import CreateModal from './create.vue';
import RequestYearToolbar from '../../shared/RequestYearToolbar.vue';
import List from './list.vue';
import { endOfDate, startOfDate } from '../../../../../../utility/helper';
import moment from 'moment/moment';
import { getPaginatedRequestRecordsByUserV2 } from '@/services/requests.services';
import { normalizeRequest } from '../../shared/normalizeRequest';

export default {
    components: {
        RequestYearToolbar,
        List,
        CreateModal,
    },
    data() {
        return {
            isLoading: false,
            requestList: [],
            selectedYear: moment().year(),
            selectedUser: localStorage.getItem('user_id'),
            currentPage: 1,
            totalCount: 0,
            limit: 50,
        };
    },
    created() {
        this.handleReload();
    },
    methods: {
        handleCreateButton() {
            this.$refs.CreateRequest.openModal({ userId: this.selectedUser }, false);
        },
        buildFilter() {
            const yearStart = moment({ year: this.selectedYear, month: 0, date: 1 });
            return {
                type: 'leave',
                createdAt: { $gte: startOfDate(yearStart), $lte: endOfDate(moment(yearStart).endOf('year')) },
            };
        },
        handleYearChanged(year) {
            this.selectedYear = year;
            this.currentPage = 1;
            this.handleReload();
        },
        handleOnPageChanged(page) {
            this.currentPage = page;
            this.fetchRequests();
        },
        handleReload() {
            this.fetchRequests();
        },
        fetchRequests() {
            this.isLoading = true;
            getPaginatedRequestRecordsByUserV2(this.buildFilter(), this.currentPage, this.limit)
                .then((res) => {
                    this.requestList = (res.data.data || []).map(normalizeRequest);
                    this.totalCount = res.data.totalCount || 0;
                })
                .catch(() => {
                    this.$Message.error('Failed to get leave requests');
                    this.requestList = [];
                    this.totalCount = 0;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
